interface QueryLoadingState {
  isPending?: boolean
  isLoading: boolean
}

/** React Query v5：首屏 pending 时 isLoading 可能为 false，需合并判断 */
export const isQueryLoading = (query: QueryLoadingState): boolean => {
  return !!(query.isPending || query.isLoading)
}

export const isQuerySettled = (
  query: QueryLoadingState & { isError: boolean }
): boolean => {
  return !isQueryLoading(query) && !query.isError
}
